import { wrapMiddlewaresWithSentry } from '@sentry/tanstackstart-react';
import {
  sentryGlobalFunctionMiddleware,
  sentryGlobalRequestMiddleware
} from '@sentry/tanstackstart-react';
import { createStart } from '@tanstack/react-start';
import { orpcErrorAdapter } from '#src/serializationAdapaters/orpcErrorAdapter.ts';
import { searchParamErrorAdapter } from '#src/serializationAdapaters/searchParamErrorAdapter.ts';

export const startInstance = createStart(() => ({
  defaultSsr: false,
  functionMiddleware: wrapMiddlewaresWithSentry({ sentryGlobalFunctionMiddleware }),
  requestMiddleware: wrapMiddlewaresWithSentry({ sentryGlobalRequestMiddleware }),
  serializationAdapters: [orpcErrorAdapter, searchParamErrorAdapter]
}));
